<div class="oms-card" [ngClass]="hasBorder ? 'border-card' : ''">
  <ng-content></ng-content>
</div>
